import { render, staticRenderFns } from "./relatedWishlists.vue?vue&type=template&id=475782fd&scoped=true&lang=pug"
import script from "./relatedWishlists.vue?vue&type=script&lang=js"
export * from "./relatedWishlists.vue?vue&type=script&lang=js"
import style0 from "./relatedWishlists.vue?vue&type=style&index=0&id=475782fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475782fd",
  null
  
)

export default component.exports